export enum UploadsRoles {
  VIEWER = 'roles.uploadsViewer',
  PERSISTER = 'roles.uploadsPersister',
  DELETER = 'roles.uploadsDeleter',
  BULK_EXPORTER = 'roles.uploadsBulkExporter',
}
